import { useState } from 'react';

import Alert from '../../../dashboard/components/common/base/Alert';
import { consumeIngestNavigationFlag } from '../utils/ingest-navigation-flag';

/**
 * Shown when the visitor arrived by opening the ingest URL (`/e/{id}`) in their browser and
 * the edge middleware redirected them here.
 *
 * That redirect deliberately does NOT capture the request, so without this notice someone
 * testing a `GET` webhook from their address bar would land on an inspect page with nothing
 * new on it — one confusion swapped for another.
 */
const IngestNavigationNotice: React.FC = () => {
  // Read (and clear) the flag on mount, so a reload doesn't resurrect the notice.
  const [arrived_from_ingest, setArrivedFromIngest] = useState(() => consumeIngestNavigationFlag());

  if (!arrived_from_ingest) {
    return null;
  }

  return (
    <Alert
      info
      inline
      m={{ x: 4, t: 4 }}
      title="That request wasn't captured"
      action={{ label: 'Dismiss', onClick: () => setArrivedFromIngest(false) }}>
      You opened this test URL's ingestion address in a browser, so we brought you here rather than
      capturing that request. Send a request to the ingestion URL from your app, curl, or the
      webhook library below and it will show up here.
    </Alert>
  );
};

export default IngestNavigationNotice;
